import { render, staticRenderFns } from "./VisualizacaoDocumento.vue?vue&type=template&id=68a854b7&"
import script from "./VisualizacaoDocumento.vue?vue&type=script&lang=js&"
export * from "./VisualizacaoDocumento.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacaoDocumento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports